import { fileObject } from "@boark/shared/types/file-object";
import {
  faFile,
  faFileExcel,
  faFilePdf,
  faFilePowerpoint,
  faFileText,
  faFileWord,
  faImage,
} from "@fortawesome/free-regular-svg-icons";
import { faFolder } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function FileIcon({ object }: { object: fileObject }) {
  switch (object.type) {
    case "file":
      return <FontAwesomeIcon icon={fileTypeIcon(object)} />;
    case "folder":
      return <FontAwesomeIcon icon={faFolder} />;
    default:
      return null;
  }
}

function fileTypeIcon(object: fileObject) {
  const fileExtension = object.name.split(".").pop();
  if (fileExtension && isImageExtension(fileExtension)) {
    return faImage;
  }
  switch (fileExtension) {
    case "pdf":
      return faFilePdf;
    case "doc":
      return faFileWord;
    case "xls":
      return faFileExcel;
    case "ppt":
      return faFilePowerpoint;
    case "txt":
      return faFileText;
    default:
      return faFile;
  }
}

function isImageExtension(fileExtension: string) {
  return [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "tiff",
    "ico",
    "webp",
    "svg",
    "heic",
    "heif",
  ].includes(fileExtension);
}
